module.exports = __webpack_public_path__ + "static/media/2.85db00cf.png";